
import GoodsListPage from '@/components/GoodsListPage'
import GoodsCard from '@/components/GoodsCard';
import FilterDropdown from '@/components/FilterDropdown'
import OrderBoxTabTitle from '@/components/OrderBox/OrderBoxTabTitle.vue'

export default {
	components: {
		GoodsListPage,
		FilterDropdown,
		GoodsCard,
		OrderBoxTabTitle

	},
	props: {
		tabTitle: {
			type: String
		},
		managementStatus: {
			type: Boolean
		},
		jumpUrl: {
			type: String
		}
	},
	data() {
		return {
			lists: [],
			loading: true,
			pageInfo: {
				page: 1,
				pageSize: this.jumpUrl ? 5 : 20,
				total: 0
			},
			// 全选状态
			checkAll: false,
			// 已选账号
			checkedIds: [],
			// 优惠标签
			marketingTypes: ['', '限时秒杀', '限时优惠', '有降价'],
			// 选择游戏
			selectedGame: { label: '全部', value: '' },
			// 选择类型
			selectedType: { label: '全部', value: '' },
			// 选择时间
			selectedTime: { label: '全部', value: '' },
			// 选择状态
			selectedStatus: { label: '全部', value: '' },
			gameList: [
				{ label: '全部', value: '' }],
			typeList: [
				{ label: '全部', value: '' }],
			timeList: [
				{ label: '全部', value: '' },
				{ label: '最近7天', value: 1 },
				{ label: '最近30天', value: 2 },
			],
			statusList: [
				{ label: '全部', value: '' },
				{ label: '在售商品', value: 1 },
				{ label: '失效商品', value: 2 },
			],
			// 2 限时秒杀 3限时优惠  1有降价
			marketingStatus: 0
		}
	},
	methods: {
		handleCurrentChange(page) {
			this.pageInfo.page = page
			this.getCollectionList()
			this.clearCheckedChange()
		},
		handleSizeChange(pageSize) {
			this.pageInfo.page = 1
			this.pageInfo.pageSize = pageSize
			this.getCollectionList()
		},
		async getCollectionList() {
			this.loading = true
			const res = await this.$api.collectionList({
				action: {
					...(this.selectedGame.label === '全部' ? {} : { gameId: this.selectedGame.value }),
					...(this.selectedType.label === '全部' ? {} : { goodsCatalogueId: this.selectedType.value }),
					...(this.selectedTime.label === '全部' ? {} : { stowedState: this.selectedTime.value }),
					...(this.selectedStatus.label === '全部' ? {} : { goodsStatue: this.selectedStatus.value }),
					...(this.marketingStatus ? { marketingStatus: this.marketingStatus } : {}),
				},
				page: this.pageInfo.page,
				pageSize: this.pageInfo.pageSize
			})

			if (!res.success) {
				this.$message.error(res.info)
				return
			}
			const data = res.data
			const now = new Date();
			const list = data.records.map(item => {

				const processedGoodsImg = item.goodsImg
					? item.goodsImg.replace('?x-oss-process=style/jpg90', '?x-oss-process=style/titleImg')
					: item.goodsImg;

				const collectionTime = item.collectionTime ? new Date(item.collectionTime) : null;
				const daysDiff = collectionTime && !isNaN(collectionTime.getTime())
					? Math.floor((now - collectionTime) / (1000 * 60 * 60 * 24))
					: 31;

				return {
					...item,
					goodsImg: processedGoodsImg,
					isWithin7Days: daysDiff <= 7,
					isWithin30Days: daysDiff <= 30
				};
			})
			this.lists = list
			this.pageInfo.page = data.page
			this.pageInfo.total = Number(data.total)
			this.loading = false

		},
		cancelHandler() {
			if (this.checkedIds.length === 0) {
				this.$message.warning('请选择商品')
				return
			}
			this.$confirm('确认取消商品收藏吗', '取消收藏', {
				confirmButtonText: '确定',
				type: 'error'
			})
				.then(async () => {
					const res = await this.$api.collectionCancelBatch({
						action: {
							collectionIdList: this.checkedIds
						}
					});
					if (!res.success) {
						this.$message.error(res.info);
						return;
					}
					this.$message.success(res.info);
					this.clearCheckedChange()
					await this.getFilterConditions()
					this.getCollectionList();
				})
				.catch(() => { })
		},
		handleBuy(item) {
			let url = `/goodsDetails/${item.goodsNo}/${item.goodsCatalogueId}?from=${encodeURIComponent('收藏列表')}`
			if (item.goodsCatalogueId !== 6) {
				url = `/generalGoodsDetails/${item.goodsNo}/${item.goodsCatalogueId}?skuId=${item.skuId || ''}&from=${encodeURIComponent('收藏列表')}`
			}
			window.open(url, '_blank')
		},
		// 选择营销状态
		handleMarketingStatusChange(type) {
			if (type === this.marketingStatus) {
				this.marketingStatus = 0
			} else {
				this.marketingStatus = type
			}
			this.getCollectionList()
		},
		// 剔除当前用户收藏列表的失效商品
		async clearProducts() {
			const res = await this.$api.cancelInvalidGoodsAPI()

			if (!res.success) {
				this.$message.error(res.info)
				return
			}

			this.$message.success('失效商品已清空')
			await this.getCollectionList()
			this.getFilterConditions()
		},
		async handleFilterChange(filterType, event) {
			switch (filterType) {
				case 'game':
					this.selectedGame = event;
					break;
				case 'type':
					this.selectedType = event;
					break;
				case 'time':
					this.selectedTime = event;
					break;
				case 'status':
					this.selectedStatus = event;
					break;
			}
			await this.getCollectionList()
			this.clearCheckedChange()
		},
		handleCheckAllChange(val) {
			if (val) {
				this.checkedIds = this.lists.map(item => item.collectionId);
			} else {
				this.checkedIds = [];
			}
			this.$emit('count', Number(this.checkedIds.length))
		},
		handleCheckedChange() {
			this.checkAll = this.checkedIds.length === this.lists.length;
			this.$emit('count', Number(this.checkedIds.length))
		},
		clearCheckedChange() {
			this.checkedIds = [];
			this.handleCheckedChange()
		},
		async getFilterConditions() {
			if (this.tabTitle) return

			const { data } = await this.$api.getCollectionSearchInfo()
			if (!data) return

			this.gameList = [
				{ label: '全部', value: '' },
				...data?.gameList.map(item => ({
					label: item.generalName,
					value: item.generalId
				}))
			]

			this.typeList = [
				{ label: '全部', value: '' },
				...data?.goodsCatalogueList.map(item => ({
					label: item.generalName,
					value: item.generalId
				}))
			]
		},
		first7DaysIndex() {
			return this.lists.findIndex(item => item.isWithin7Days);
		},
		first30DaysIndex() {
			return this.lists.findIndex(item =>
				item.isWithin30Days && !item.isWithin7Days
			);
		},
		firstOldIndex() {
			return this.lists.findIndex(item => !item.isWithin30Days);
		}
	},

	mounted() {
		this.getFilterConditions()
		this.getCollectionList()
		const tagType = this.$route.query.tagType
		this.$trackEvent({
			eventType: 'pageView',
			eventName: '访问收藏列表',
			pageSource: 'PC顶部',
			isFilter: !!tagType,
			Filter: this.marketingTypes[tagType]
		})
		this.marketingStatus = tagType ? parseInt(tagType) : 0
	}
}
